import { Form, FormControl } from "@angular/forms";
import { PanchayatMasterData, VillageData } from "src/app/types";

export interface IQuarterData {
	quarter: number,
	quarterLabel: string,
	startMonth: number,
	endMonth: number
}

export const QuarterData: IQuarterData[] = [
    { quarter: 1, quarterLabel: 'Apr-Jun', startMonth: 3, endMonth: 5 },
    { quarter: 2, quarterLabel: 'Jul-Sept', startMonth: 6, endMonth: 8 },
    { quarter: 3, quarterLabel: 'Oct-Dec', startMonth: 9, endMonth: 11 },
    { quarter: 4, quarterLabel: 'Jan-Mar' , startMonth: 0, endMonth: 2}
];

export const getYearDropDownData = () => {
    const yearDropDown: { label: string; value: string }[] = [];
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;
    const currentYear = currentMonth <= 3 ? currentDate.getFullYear() - 1 : currentDate.getFullYear();
    for (let year = 2024; year <= currentYear; year++) {
        yearDropDown.push({
            label: `${year}-${(year + 1).toString().slice(-2)}`,
            value: `${year}${(year + 1).toString().slice(-2)}`
        });
    }
    return yearDropDown;
};

export interface Quarter {
    quarter: number;
    quarterLabel: string;
}

export interface Year {
    year: number;
    yearLabel: string;
}


export interface PanchayatFilterValue extends PanchayatMasterData {
    label: string,
    value: string
}

export interface  VillageFilterValue extends VillageData {
    label: string,
    value: string
}

export interface FilterFg {
    gramPanchayat: FormControl<PanchayatFilterValue | null>,
    village: FormControl<VillageFilterValue | null>
}

export interface ShgMemberFilterFg {
    status: FormControl<FilterType<string> | null>,
    financialYears: FormControl<FilterType<string> | null>,
    quarter: FormControl<FilterType<number> | null>
}
export interface FilterType<T> {
    label: string,
    value: T
}
export interface ShgFilterData {
    gramPanchayat: PanchayatFilterValue | null,
    village: VillageFilterValue | null
}

export interface ShgMemberFilterData {
    financialYears: FilterType<string> | null,
    quarter: FilterType<number> | null,
    status: FilterType<string> | null
}
export interface LakhpatiDidiInactivationPayload {
    memberId: number;
    memberCode: string;
    stateId: number;
    blockId: number;
    memberProfileUuid: string;
    inactiveReason: string;
    inactiveRemark: string;
}

export interface InactiveLakhpatiDidi {
    memberId: number;
    stateId: number;
    blockId: number;
    memberCode: string;
    memberProfileUuid: string;
    inactiveReason: string;
    inactiveRemark: string;
    darInactiveStatus?: boolean;
    darInactiveDate?: string | null;
    profileInactiveStatus?: boolean;
    profileInactiveDate?: string | null;
    createdDate?: string;
}

export interface InactiveLakhpatiDidiResponse {
    responseCode: string;
    responseMsg: string;
    status: string;
    timestamp: string;
    size: number;
    responseData: InactiveLakhpatiDidi[];
}
